import React from "react";

const challenges = [
  {
    number: <div class="number fontColor1">1</div>,
    heading: "Technological Advancements",
    description:
      "With the rapid pace of technological change, educational institutions must stay up-to-date with the latest tools and technologies in order to deliver a modern and effective learning experience.",
  },
  {
    number: <div class="number fontColor2">2</div>,
    heading: "High Competition",
    description:
      "Educational institutions are increasingly competing with each other for students and funding, which can lead to a focus on marketing and branding rather than education itself.",
  },
  {
    number: <div class="number fontColor3">3</div>,
    heading: "Adapting to New Methodical Approaches",
    description:
      "Educational institutions must be willing to adapt to new pedagogical approaches, such as project-based learning and online education, in order to stay relevant and effective in a rapidly changing world.",
  },
  {
    number: <div class="number fontColor4">4</div>,
    heading: "Leveraging Social Media ",
    description:
      "Use social media platforms to promote your services, connect with potential students and build a community around your brand.",
  },
];

class Challenges extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: true,
      margin: 30,
      nav: false,
      dots: false,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 3,
        },
      },
    };
    return (
      <>
        <div className="section-full mobile-page-padding p-b10 bg-repeat">
          <div className="container p-t80">
            <div className="row">
              <div className="col-md-12 sx-separator-outer separator-center">
                <div className="case-banner">
                  <h2 class="ert678">The Challenges</h2>
                </div>
              </div>
              <div className="col-md-12 sx-separator-outer separator-center"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ul class="infoGraphic">
                  {challenges.map((item, index) => (
                    <li>
                      <div class="numberWrap">
                        {item.number}
                        <div class="coverWrap">
                          <div class="numberCover"></div>
                        </div>
                      </div>
                      <div class="content">
                        <h3>{item.heading}</h3>
                        <p>{item.description}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Challenges;
